const PRICES={
  'foldable':[[3,6,9.6],[7,10,9.0],[11,15,6.8],[16,20,6.3],[21,25,6.0],[26,35,5.7],[36,50,5.0],[51,74,4.6],[75,99,4.1],[100,149,3.2],[150,200,3.0],[201,300,2.7],[301,400,2.3],[401,999999,2.0]],
  'slim':[[3,6,9.6],[7,10,9.0],[11,15,6.8],[16,20,6.3],[21,25,6.0],[26,35,5.7],[36,50,5.0],[51,74,4.6],[75,99,4.1],[100,149,3.2],[150,200,3.0],[201,300,2.7],[301,400,2.3],[401,999999,2.0]],
  'stitched':[[3,6,19.5],[7,10,13.5],[11,15,9.0],[16,20,8.5],[21,25,7.8],[26,35,7.3],[36,50,5.8],[51,74,5.2],[75,99,4.8],[100,149,4.2],[150,200,4.0],[201,300,3.8],[301,400,3.6],[401,999999,3.4]],
  '5mm':[[3,6,17.5],[7,10,10.4],[11,15,8.0],[16,20,7.6],[21,25,7.2],[26,35,6.7],[36,50,5.2],[51,74,4.7],[75,99,4.2],[100,149,3.8],[150,200,3.5],[201,300,3.3],[301,400,3.1],[401,999999,3.0]],
  'overlocked':[[3,6,18.5],[7,10,11.4],[11,15,8.3],[16,20,7.9],[21,25,7.5],[26,35,7.0],[36,50,5.5],[51,74,5.0],[75,99,4.5],[100,149,4.0],[150,200,3.8],[201,300,3.6],[301,400,3.4],[401,999999,3.2]],
  'zippered':[[3,6,22.5],[7,10,15.4],[11,15,12.3],[16,20,11.9],[21,25,11.5],[26,35,11.0],[36,50,9.5],[51,74,9.0],[75,99,8.5],[100,149,8.0],[150,200,7.8],[201,300,7.6],[301,400,7.4],[401,999999,7.2]],
  'jersey':[[3,6,19.5],[7,10,12.4],[11,15,9.3],[16,20,8.9],[21,25,8.5],[26,35,8.0],[36,50,6.5],[51,74,6.0],[75,99,5.5],[100,149,5.0],[150,200,4.8],[201,300,4.6],[301,400,4.4],[401,999999,4.2]]
};

function getRate(t,q){
  for(const [a,b,r] of PRICES[t]){ if(q>=a && q<=b) return r; }
  return PRICES[t].at(-1)[2];
}

function calcUpdate(){
  var qEl=document.getElementById('calc-qty');
  var tEl=document.getElementById('calc-type');
  if(!qEl||!tEl) return;
  var q=Math.max(1,parseInt(qEl.value)||1);
  var t=tEl.value;
  var r=getRate(t,q);
  var total=q*r;
  var base=PRICES[t][0][2];
  var pct=Math.round((base-r)/base*100);
  document.getElementById('res-total').textContent='$'+total.toFixed(2);
  document.getElementById('res-unit').textContent='$'+r.toFixed(2)+' per unit · '+q+' pcs';
  var s=document.getElementById('res-save');
  if(pct>0){s.textContent='You save '+pct+'% vs smallest order';s.style.display='';}
  else{s.style.display='none';}
  document.getElementById('progress-fill').style.width=Math.min(100,Math.max(0,(q-1)/400*100))+'%';
}

function filterCards(type,btn){
  document.querySelectorAll('.filter-btn').forEach(function(b){b.classList.remove('active');});
  btn.classList.add('active');
  var count=0;
  document.querySelectorAll('.price-card').forEach(function(c){
    var show=type==='all'||c.dataset.type===type;
    c.style.display=show?'':'none';
    if(show) count++;
  });
  var el=document.getElementById('card-count');
  if(el) el.textContent='Showing '+count+(count===1?' product':' products')+(type!=='all'?' — '+btn.textContent.trim():'');
}

function mobFilter(type,btn){
  document.querySelectorAll('.mob-tab').forEach(function(b){b.classList.remove('active');});
  btn.classList.add('active');
  document.querySelectorAll('.price-card').forEach(function(c){
    c.classList.toggle('mob-show',type==='all'||c.dataset.type===type);
  });
}

document.addEventListener('DOMContentLoaded',function(){
  // Filter buttons
  document.querySelectorAll('.filter-btn').forEach(function(btn){
    btn.addEventListener('click',function(){filterCards(this.dataset.filter,this);});
  });
  // Mobile tabs
  document.querySelectorAll('.mob-tab').forEach(function(btn){
    btn.addEventListener('click',function(){mobFilter(this.dataset.filter,this);});
  });
  // Calculator
  var qEl=document.getElementById('calc-qty');
  var tEl=document.getElementById('calc-type');
  if(qEl) qEl.addEventListener('input',calcUpdate);
  if(tEl) tEl.addEventListener('change',calcUpdate);
  calcUpdate();

  // Price row toggle
  document.querySelectorAll('.price-toggle-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var card=this.closest('.price-card');
      var expanded=this.classList.contains('expanded');
      card.querySelectorAll('tbody tr[style="display:none"]').forEach(function(row){
        row.style.display='table-row';
      });
      if(expanded){
        // collapse - re-hide non-preview rows
        var rows=card.querySelectorAll('tbody tr');
        var n=rows.length;
        var keep=new Set([0, Math.floor(n/3), Math.floor(2*n/3), n-1]);
        rows.forEach(function(row,i){
          if(!keep.has(i)) row.style.display='none';
        });
        this.classList.remove('expanded');
        this.querySelector('span') && (this.querySelector('span').textContent='Show all prices');
        this.lastChild.textContent='Show all prices';
      } else {
        this.classList.add('expanded');
        this.lastChild.textContent='Show less';
      }
    });
  });
});
